'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Html } from '@react-three/drei';
import { useFrame, useThree } from '@react-three/fiber';
import { useEffect, useMemo, useState } from 'react';
import * as THREE from 'three';
import SpaceRenderer from '../../rendering/components/SpaceRenderer.js';
import { createCameraGraphDiagnosticsProjection } from '../cameraGraphDiagnostics.js';
/** Mounting this component is the sole entry to diagnostic resolution, state and resources. */
export function CameraGraphDiagnosticsRenderer(props) {
    const camera = useThree((state) => state.camera);
    const size = useThree((state) => state.size);
    const [fov, setFov] = useState(() => camera instanceof THREE.PerspectiveCamera ? camera.fov : props.initialPose.fov);
    useFrame(() => {
        if (camera instanceof THREE.PerspectiveCamera && camera.fov !== fov)
            setFov(camera.fov);
    });
    const projection = useMemo(() => createCameraGraphDiagnosticsProjection(), []);
    useEffect(() => () => projection.clear(), [projection]);
    const frame = useMemo(() => projection.project(props.renderFrame, props.playbackFrame, { ...props.initialPose, fov }, size.width / size.height), [projection, props.renderFrame, props.playbackFrame, props.initialPose, fov, size.width, size.height]);
    const declaration = props.playbackFrame.spaceRenderOptions?.camera;
    const view = declaration?.activeView;
    const station = view === undefined ? undefined : declaration?.graph?.views[view]?.station;
    return (_jsxs(_Fragment, { children: [_jsx(SpaceRenderer, { derivationFrame: frame }), _jsx(Html, { fullscreen: true, calculatePosition: (_object, _camera, viewport) => [viewport.width / 2, viewport.height / 2], style: { pointerEvents: 'none' }, children: _jsxs("div", { style: { position: 'absolute', top: 8, right: 8, padding: '4px 8px',
                        maxWidth: 'calc(100% - 16px)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                        background: '#17212bd9', color: '#e5edf4', font: '11px monospace', borderRadius: 4 }, children: ["Camera: ", station ?? 'live', " / ", view ?? 'no view', " | ", declaration?.navigationMode ?? 'free', " | ", fov.toFixed(1), " deg"] }) })] }));
}
